import { Button, Stack } from "@mui/material";
import { GridFooterContainer, GridPagination } from "@mui/x-data-grid";

function CustomFooter({ extraButtons }) {
    return (
        <GridFooterContainer sx={{ justifyContent: "space-between", px: 2 }}>
            {extraButtons ? (
                <Stack direction="row" spacing={1}>
                    {extraButtons}
                </Stack>
            ) : null}
            <GridPagination />
        </GridFooterContainer>
    );
}

export default CustomFooter;
